import client  from './client'
import qString from 'query-string';
import { authStore } from '@/store/store'

async function login(payload){
    try {
        const info = await client.post('/auth/login', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function logout(){
    try {
        const info = await client.post('/auth/logout')
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function authById(payload){
    try{
        const info = await client.post('/auth/identity', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function mfaAuth(payload){
    try{
        const info = await client.post('/auth/mfa', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function register(payload){
    try{
        const info = await client.post('/persona/create-profile', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function validateCode(payload){
    try{
        const info = await client.post('/persona/verify-profile', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function initPasswordReset(payload){
    try{
        const info = await client.post('/persona/forgot-password', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function resetPassword(payload){
    try{
        const info = await client.patch('/persona/reset-password', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function getInfo(){
    try{
        const info = await client.get('/persona')
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function userUpdateProfile(payload){
    try{
        const info = await client.patch('/persona', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function generateMFA(){
    try{
        const info = await client.post('/persona/authenticator/generate')
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function validateMFA(code){
    try{
        const info = await client.post('/persona/authenticator/verify', { code })
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function addKYCIdentity(payload){
    try{
        const info = await client.post('/kyc/identity', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function getSupportedCurrency(){
    try{
        const info = await client.get('/kyc/bank-verification/supported-currency')
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function updateKYCBankVerification(payload){
    try{
        const info = await client.patch('/kyc/bank-verification', payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}


function userRouteDecider(user){ //, path=''
    let route = `/dashboard`
    let kycReady = true
    if (!user.is_kyc && user.role !='BOT-AGENT'){ //exluce role in this check
        /*
            kycReady = false
            if (!user.is_identity_verified){
                route = `/on-boarding/persona`
                kycReady = false
            }else{
                route = `/on-boarding/bank-verification/choose-currency`
                kycReady = false
            }
        */
    }

    /*
        if (!user?.is_mfa){
            kycReady = false
            route = `/profile/mfa`
        }

        if (user?.is_mfa_login){
            kycReady = false
            route = `/profile/mfa-verification`
        }
    */

    return {route,kycReady}
}

// admin related stuff
async function getUsers(query={}){
    try{
        const info = await client.get(`/a/user?${qString.stringify(query)}`)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function getUser(identity){
    try{
        const info = await client.get(`/a/user/${identity}`)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function addAgent(payload){
    try{
        const info = await client.post(`/a/create-agent`, payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function merchantInvitation(payload){
    try{
        const info = await client.post(`/a/merchant/invitation`, payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function userBroadcast(payload){
    try{
        const info = await client.post(`/a/wa-broadcast-message`, payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function updateProfile(identity, payload){
    try{
        const info = await client.patch(`/a/user/${identity}`, payload)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function getKYC(identity){
    try{
        const info = await client.get(`/a/user/kyc/${identity}`)
        return info
    }catch(err){
        return Promise.reject(err)
    }
}

async function userClientAuth(identity){
    const store = authStore();
    const profile = store.decryptAuth.profile
    if(!profile){
        const info = await authById({id: identity})
        let user = info?.data.data
        if (user){
            user.token = info.headers.xauth
            store.logIn(user)
            location.reload()
        }
    }
}

export default {
    login,
    logout,
    authById,
    mfaAuth,
    register,
    validateCode,
    initPasswordReset,
    resetPassword,
    getInfo,
    userBroadcast,
    addKYCIdentity,
    getSupportedCurrency,
    updateKYCBankVerification,
    userRouteDecider,
    getUsers,
    getUser,
    updateProfile,
    userUpdateProfile,
    getKYC,
    userClientAuth,
    addAgent,
    generateMFA,
    validateMFA,
    merchantInvitation,
}